import { PrismicRichText } from "@prismicio/react";
import React from 'react';
import ScriptInjector from "../script-injector";

export const ResourcePageBlock = (props) => {

    const sc = props.slice.primary;

    const stats = props.slice.items;

    const components = {
        label: ({ children }) => (
          <sup>{children}</sup>
        ),
    }

    return (
        <section className="gutter top res-sec">
            <div className="res-section wrapper flex flex-col md:flex-row justify-between gap-2 md:gap-24 pb-14 md:pb-24">
                <div className="w-full md:w-1/5">
                    <div className="res-label">{sc.section_name}</div>
                </div>
                <div className="w-full md:w-4/5 self-start">
                    <PrismicRichText field={sc.content.richText} components={components} />
                    <ScriptInjector html={sc.custom} />
                    {stats.length > 0 && (
                        <div className="relative flex flex-col md:flex-row gap-8 md:gap-20 mt-16">
                            {stats.map((data, index) => (
                            <div className="w-full md:w-1/3" key={index}>
                                <span className={"dta block text-" + data.theme}>{data.data_number}</span>
                                <span className="text-base text-grey">
                                <PrismicRichText field={data.data_text.richText} components={components} />
                                </span>
                            </div>
                            ))}
                        </div>
                        )}
                </div>
                
            </div>
        </section>
    );
}

